import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BDropdown, BDropdownItem, BDropdownText, BModal } from "bootstrap-vue";
import { toRef } from "vue";
import {} from "@/api";
import { deleteAllHiddenContent, purgeAllDeletedContent, unhideAllHiddenContent, } from "@/components/History/model/crud";
import { iframeRedirect } from "@/components/plugins/legacyNavigation";
import { useHistoryContentStats } from "@/composables/historyContentStats";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DefaultOperations',
    props: {
        history: null
    },
    emits: ["update:operation-running"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCog);
        const { numItemsDeleted, numItemsHidden } = useHistoryContentStats(toRef(props, "history"));
        function onCopy() {
            iframeRedirect("/dataset/copy_datasets");
        }
        function unhideAll() {
            runOperation(() => unhideAllHiddenContent(props.history));
        }
        function deleteAllHidden() {
            runOperation(() => deleteAllHiddenContent(props.history));
        }
        function purgeAllDeleted() {
            runOperation(() => purgeAllDeletedContent(props.history));
        }
        async function runOperation(operation) {
            emit("update:operation-running", props.history.update_time);
            await operation();
            emit("update:operation-running", props.history.update_time);
        }
        return { __sfc: true, props, emit, numItemsDeleted, numItemsHidden, onCopy, unhideAll, deleteAllHidden, purgeAllDeleted, runOperation, faCog, FontAwesomeIcon, BDropdown, BDropdownItem, BDropdownText, BModal, deleteAllHiddenContent, purgeAllDeletedContent };
    }
});
